import React from 'react';
import { wHeadingListConfig } from '../../config/wysiwyg';
import { ToolbarSelect } from '../ToolbarSelect';
export const WToolbarTextSelect = ({ focus, onClick, editor, className, }) => {
    const items = React.useMemo(() => wHeadingListConfig.data, []);
    return (React.createElement(ToolbarSelect, { items: items, focus: focus, editor: editor, onClick: onClick, className: className }));
};
